/* One trailer at a time.

   THE FAULT, ONCE IT WAS ACTUALLY READ RATHER THAN GUESSED AT.

   trailerData is the trailer on screen, and it is written by BOTH routes. A
   VIN search fills it with vinNumber: "04178", modelName: "SUPER SPORT". A
   model filter fills the same key with modelName: "Super Tourer" and no
   vinNumber at all, tagged source: "model-filter".

   lastSearchedTrailer is a separate record and it only ever holds the last VIN
   search. It is what the VIN chip reads from.

   So the heading and the chip were reading different records, and after a VIN
   search for 04178 followed by a browse to a Super Tourer the screen said
   "2026 Futura Super Tourer" with "VIN 04178" beside it. Neither record was
   wrong. Putting them on one line was.

   THE RULE. The VIN chip may only appear when the trailer on screen IS that
   VIN's trailer: trailerData.vinNumber present and equal to
   lastSearchedTrailer.vinNumber. The moment a model filter replaces
   trailerData, that stored VIN is no longer describing what the customer is
   looking at, so it is cleared and the chip goes with it. A later VIN search
   writes both records together and they agree again.

   WHAT WAS TRIED FIRST AND WAS WRONG. Two earlier passes: wrapping
   Storage.prototype.setItem, which the extension bypasses entirely by
   assigning localStorage.key = value, and comparing timestamps on
   fxTrailerPick, which is written at commit and not at every browse and so
   missed the case in the bug report. Both are gone. This version compares the
   two records that the screen itself reads, which is the only comparison that
   can be out of step with what is displayed.

   ABSENT IS NOT INCOHERENT. If trailerData is missing, lastSearchedTrailer is
   left alone. It is missing on an ordinary reload before the extension
   rehydrates, and clearing the VIN there would lose it on every page load.

   The load time half runs inline from sections/fx-extui.liquid, because it has
   to settle a stale pair before anything hydrates from it. */
(function () {
  'use strict';

  var DATA = 'trailerData', LAST = 'lastSearchedTrailer';

  function read(k) {
    try { return JSON.parse(window.localStorage.getItem(k) || 'null'); } catch (e) { return null; }
  }
  function drop(k) {
    try { window.localStorage.removeItem(k); } catch (e) {}
  }
  function norm(s) {
    return String(s == null ? '' : s).toUpperCase().replace(/[^A-Z0-9]+/g, '');
  }

  /* Clearing storage fixes the next page view and not the one on screen,
     because the modal renders from memory. The chip is ours: fx-ext-vinchip.js
     builds it as .fx-vinchip. Taking it out is what stops the screen making
     the false claim right now. An honest render is free to put it back. */
  function dropVinChip() {
    var list = document.querySelectorAll('.fx-vinchip');
    for (var i = 0; i < list.length; i++) {
      if (list[i].parentNode) list[i].parentNode.removeChild(list[i]);
    }
  }

  function settle() {
    var data = read(DATA);
    var last = read(LAST);
    if (!data || !last) return;

    var onScreen = norm(data.vinNumber);
    if (onScreen && onScreen === norm(last.vinNumber)) return;

    dropVinChip();
    drop(LAST);
  }

  settle();

  /* Often enough that a wrong chip never survives a glance, cheap enough that
     it does not matter: two reads and a compare. */
  setInterval(settle, 400);
  window.addEventListener('pageshow', settle);
  document.addEventListener('visibilitychange', settle);
})();
